import { render } from "./isadimCard.vue?vue&type=template&id=2c321b39"
import script from "./isadimCard.vue?vue&type=script&lang=js"
export * from "./isadimCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__